var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Loading } from "@/shared/presentation/components/loading";
import { Button, Center, Divider, Flex, Link, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text, } from "@reverb-ui/react";
import React, { useEffect, useState } from "react";
var OtpQrCodeModal = function (_a) {
    var isOpen = _a.isOpen, onSubmit = _a.onSubmit, onClose = _a.onClose, generateQrCode = _a.generateQrCode;
    var _b = useState(""), qrCode = _b[0], setQrCode = _b[1];
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var generateQrCodeTfa = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setLoading(true);
            generateQrCode()
                .then(setQrCode)
                .finally(function () { return setLoading(false); });
            return [2 /*return*/];
        });
    }); };
    useEffect(function () {
        if (isOpen)
            generateQrCodeTfa();
        else {
            setQrCode("");
            setLoading(false);
        }
    }, [isOpen]);
    return (React.createElement(Modal, { isOpen: isOpen, onClose: onClose, size: "xl" },
        React.createElement(ModalOverlay, null),
        React.createElement(ModalContent, null,
            React.createElement(ModalHeader, null, "Two Factor Authentication"),
            React.createElement(ModalCloseButton, null),
            React.createElement(Divider, null),
            React.createElement(ModalBody, { overflow: "auto" },
                React.createElement(Text, { my: "2" },
                    "Scan the following QR Code using the",
                    " ",
                    React.createElement("strong", null, "Google Authenticator"),
                    " app to enable two-factor authentication."),
                React.createElement(Text, null,
                    "Download the app on",
                    " ",
                    React.createElement(Link, { color: "blue", href: "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en&gl=US", isExternal: true }, "Android"),
                    " ",
                    "or",
                    " ",
                    React.createElement(Link, { color: "blue", href: "https://apps.apple.com/us/app/google-authenticator/id388497605", isExternal: true }, "IOS")),
                React.createElement(Center, { my: "8", flexDirection: "column" },
                    isOpen && qrCode && (React.createElement("img", { src: qrCode, alt: "QR Code Token", title: "QR Code Token" })),
                    isOpen && loading && React.createElement(Loading, null))),
            React.createElement(Divider, null),
            React.createElement(ModalFooter, null,
                React.createElement(Flex, { align: "center", justifyContent: "space-between", w: "full" },
                    React.createElement(Button, { borderColor: "blue.500", variant: "outline", colorScheme: "blue", color: "blue.500", onClick: onClose, title: "Close" }, "Close"),
                    React.createElement(Button, { colorScheme: "blue", onClick: onSubmit, title: "Confirm" }, "Confirm"))))));
};
export default OtpQrCodeModal;
